import type { Product } from "@/services/types";

const featuredProducts = [
    {
        id: 10408861,
        name: "1 Kg Zanahorias",
        price: 790,
        compare_at_price: 1190,
        images: [
            {
                id: 18024881,
                url: "https://images.jumpseller.com/store/maifud/10408861/0D6FF30C-5743-4D47-87ED-7D6EFFCD2ABB.jpeg?1722868569",
                position: 1,
            },
            {
                id: 18024882,
                url: "https://images.jumpseller.com/store/maifud/10408861/BAACF9FB-42E7-482B-B9BE-3AD367FDE849.jpeg?1722868569",
                position: 3,
            },
            {
                id: 51285055,
                url: "https://images.jumpseller.com/store/maifud/10408861/_DSC0918.jpg?1722868569",
                position: 4,
            },
            {
                id: 51285056,
                url: "https://images.jumpseller.com/store/maifud/10408861/_DSC0956.jpg?1722868569",
                position: 5,
            },
        ],
    },
    {
        id: 10699942,
        name: "1 Kg Manzanas Fuji",
        price: 1490,
        compare_at_price: 2490,
        images: [
            {
                id: 31963604,
                url: "https://images.jumpseller.com/store/maifud/10699942/90B61A8A-6610-4FA9-BDEA-3E9EDA59F433.jpeg?1685206143",
                position: 1,
            },
            {
                id: 35789583,
                url: "https://images.jumpseller.com/store/maifud/10699942/1298FAAF-6B38-4E91-8E02-23BE85701011.jpeg?1685206143",
                position: 2,
            },
        ],
    },
    {
        id: 10999718,
        name: "1 Kg Papas Grandes",
        price: 990,
        compare_at_price: 1390,
        images: [
            {
                id: 18727134,
                url: "https://images.jumpseller.com/store/maifud/10999718/IMG_2389.jpg?1658247798",
                position: 1,
            },
        ],
    },
    {
        id: 21807564,
        name: "Barra Protein Caramel Salted Nut (5 Un)",
        price: 3490,
        compare_at_price: 5000,
        images: [
            {
                id: 41214890,
                url: "https://images.jumpseller.com/store/maifud/21807564/barras_protein_2.jpg?1697857793",
                position: 1,
            },
        ],
    },
    {
        id: 8880147,
        name: "1 Kg Cebollas Moradas",
        price: 1290,
        compare_at_price: 1990,
        images: [
            {
                id: 14530804,
                url: "https://images.jumpseller.com/store/maifud/8880147/Cebollas_Moradas.jpg?1655572835",
                position: 1,
            },
        ],
    },
    {
        id: 10999736,
        name: "1 Kg Limones",
        price: 1650,
        compare_at_price: 2090,
        images: [
            {
                id: 24031895,
                url: "https://images.jumpseller.com/store/maifud/10999736/83596D15-B20E-4B31-B81B-963D6CB05D9B.jpeg?1722435641",
                position: 1,
            },
            {
                id: 18727137,
                url: "https://images.jumpseller.com/store/maifud/10999736/A34F10D2-33E3-4B51-A89C-08046CEF4ED1.jpeg?1722435641",
                position: 2,
            },
            {
                id: 51285458,
                url: "https://images.jumpseller.com/store/maifud/10999736/_DSC09352.jpg?1722435641",
                position: 4,
            },
        ],
    },
    {
        id: 12700466,
        name: "Bandeja 30 Huevos Extra",
        price: 10990,
        compare_at_price: 12690,
        images: [
            {
                id: 68687405,
                url: "https://cdnx.jumpseller.com/maifud/image/68687405/17-30-HUEVOS.jpg?",
                position: 1,
            },
            {
                id: 21598356,
                url: "https://images.jumpseller.com/store/maifud/12700466/_DSC1226.jpg?1732875777",
                position: 2,
            },
            {
                id: 21598357,
                url: "https://images.jumpseller.com/store/maifud/12700466/IMG_2545.jpg?1732875777",
                position: 3,
            },
        ],
    },
    {
        id: 25360375,
        name: "1 Kg Palta Hass",
        price: 5190,
        compare_at_price: 6490,
        images: [
            {
                id: 25360375,
                url: "https://cdnx.jumpseller.com/maifud/image/25360375/IMG_6001.jpg?1658254990",
                position: 1,
            },
        ],
    },
] as Product[];

export default featuredProducts;
